import React from "react";

/**
 * Visual separator between components.
 */
export function Divider() {
  return <div className="divider" />;
}
